































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { BaseStation } from '@/types/core';

import VueError from '@/components/VueError.vue';
import EnterpriseId from '@/components/EnterpriseId.vue';
import TimestampAgo from '@/components/TimestampAgo.vue';

import tippy from 'tippy.js';

@Component({
  components:{
    VueError,
    EnterpriseId,
    TimestampAgo
  }
})
export default class BssRow extends Vue {

  error:string = '';
  @Prop({ default: {},  type: Object}) bss!: BaseStation;

  // to support the header
  @Prop({ default: 0,  type: Number}) index!: number;

  goToBaseStationPage(lrrId:string) {
    this.$router.push(`/assets/basestation/${lrrId}`);
  }

  async mounted() {
    // nothing yet

    tippy('[data-tippy-content]');
  }

  formatName(name:string): string {
    if(name.length <= 60)
      return name;
    return name.substring(0, 60) + '...';
  }
}

